import React from 'react';
type CtaButtonProps = {
  className?: string;
  href?: string;
};
export function CtaButton({
  className = '',
  href = '#pricing'
}: CtaButtonProps) {
  return <a href={href} className={`flex w-full items-center justify-center rounded-2xl bg-[#00c853] px-6 py-5 text-center text-lg font-extrabold text-white shadow-lg shadow-[#00c853]/20 transition-colors hover:bg-[#00b34a] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#00c853]/40 sm:text-xl ${className}`} data-id="element-57" data-mp="2opit0otsro3">
      🚀 I WANT NETBALL READY NOW
    </a>;
}